export interface SchoolTheme {
  id: string;
  name: string;
  short: string;
  /** Brand primary — replaces #8b5cf6 throughout the UI */
  primary: string;
  /** Secondary accent */
  secondary: string;
  /** Displayed in the picker badge */
  emoji: string;
}

export const SCHOOL_THEMES: SchoolTheme[] = [
  {
    id: 'incubs',
    name: 'Incubs',
    short: 'INCUBS',
    primary: '#8b5cf6',
    secondary: '#00d9b4',
    emoji: '🐻',
  },
  {
    id: 'harvard',
    name: 'Harvard',
    short: 'HARV',
    primary: '#a51c30',
    secondary: '#b8a04a',
    emoji: '🎓',
  },
  {
    id: 'yale',
    name: 'Yale',
    short: 'YALE',
    primary: '#0f4d92',
    secondary: '#a39161',
    emoji: '🐶',
  },
  {
    id: 'mit',
    name: 'MIT',
    short: 'MIT',
    primary: '#8b1a1a',
    secondary: '#a2aaad',
    emoji: '🦫',
  },
  {
    id: 'stanford',
    name: 'Stanford',
    short: 'SU',
    primary: '#8c1515',
    secondary: '#b28a00',
    emoji: '🌲',
  },
  {
    id: 'columbia',
    name: 'Columbia',
    short: 'CU',
    primary: '#1d4e9f',
    secondary: '#c8a951',
    emoji: '🦁',
  },
  {
    id: 'princeton',
    name: 'Princeton',
    short: 'PU',
    primary: '#e07800',
    secondary: '#0a0a0a',
    emoji: '🐯',
  },
  {
    id: 'penn',
    name: 'Penn',
    short: 'UPENN',
    primary: '#990000',
    secondary: '#011f5b',
    emoji: '🦅',
  },
  {
    id: 'cornell',
    name: 'Cornell',
    short: 'COR',
    primary: '#b31b1b',
    secondary: '#222222',
    emoji: '🐻',
  },
  {
    id: 'dartmouth',
    name: 'Dartmouth',
    short: 'DAR',
    primary: '#00693e',
    secondary: '#c8a951',
    emoji: '🌲',
  },
  {
    id: 'brown',
    name: 'Brown',
    short: 'BRN',
    primary: '#4e3629',
    secondary: '#e41c39',
    emoji: '🐻',
  },
  {
    id: 'duke',
    name: 'Duke',
    short: 'DUKE',
    primary: '#012169',
    secondary: '#c8a951',
    emoji: '👹',
  },
];

export const INCUBS_THEME = SCHOOL_THEMES[0];
